import React from 'react';
import { Card, CardContent, Typography, Box, CircularProgress, alpha } from '@mui/material';

interface StatCardProps {
  label: string;
  value: number | null;
  icon: React.ReactNode;
  accentColor?: string;
  footer?: React.ReactNode;
}

const StatCard: React.FC<StatCardProps> = ({ label, value, icon, accentColor = '#10B981', footer }) => (
  <Card
    sx={{
      height: '100%',
      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
      '&:hover': {
        transform: 'translateY(-2px)',
        boxShadow: `0 8px 24px ${alpha(accentColor, 0.12)}`,
      },
    }}
  >
    <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', mb: 2 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: 48,
            height: 48,
            borderRadius: 2.5,
            bgcolor: alpha(accentColor, 0.1),
            color: accentColor,
          }}
        >
          {icon}
        </Box>
      </Box>
      <Typography variant="body2" color="text.secondary" fontWeight={500} gutterBottom>
        {label}
      </Typography>
      <Typography variant="h3" fontWeight={700} sx={{ letterSpacing: '-0.02em', lineHeight: 1.2 }}>
        {value === null ? <CircularProgress size={28} sx={{ color: accentColor }} /> : value.toLocaleString('tr-TR')}
      </Typography>
      {footer && (
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1.5, display: 'block' }}>
          {footer}
        </Typography>
      )}
    </CardContent>
  </Card>
);

export default StatCard;
